import React from "react";
import HelpCenter from "../components/HelpCenter";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const HelpCenterPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Help Center" />
      <HelpCenter />
    </>
  );
};

export default HelpCenterPage;